













import Vue from "vue";
import VueCookies from "vue-cookies";
import Cart from "./components/Cart.vue";
import { ClientsideCart } from "./types/clientSideCart";
import * as cartProvider from "./providers/CartProvider";

Vue.use(VueCookies);
export default Vue.extend({
  name: "app",
  data(): ClientsideCart {
    return {
      lineItems: [],
      checkoutURL: undefined as string,
      productType: undefined,
      lineItemsLoaded: false,
      isEmpty: true,
      deliveryExpectation: "",
      madeIn: "",
      deliveryHighlighting: undefined
    };
  },
  created: async function() {
    await cartProvider.initialize(this);
  },
  components: {
    Cart,
  },
});
